module.exports = __webpack_public_path__ + "static/media/Group 17.b2978a95.svg";